module.exports = __webpack_public_path__ + "static/img/pc_lx_banner.efb6c8a.png";